var $=jQuery;
jQuery(document).ready(function ($) {

   

    $('.st-point .banner__buttons a').on('click', function (e) {
    e.preventDefault();

    const $block = $(this).closest('[data-block-id]');
    const $points = $block.find('.hotspot-point[data-product]');
    const handles = [];

    // Collect handles
    $points.each(function () {
      const handle = $(this).data('product');
      if (handle) handles.push(handle);
    });

    const items = [];
    let completed = 0;

    // Get product info for each handle
    handles.forEach(function (handle, index) {
      $.getJSON(`/products/${handle}.js`, function (product) {
        const variantId = product.variants[0].id;
        items.push({ id: variantId, quantity: 1 });

        completed++;

        // When all product data is fetched
        if (completed === handles.length) {
          // Send ONE add-to-cart request with all items
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: items }),
            dataType: 'json',
            contentType: 'application/json',
            success: function () {
              const url = new URL(window.location.href);
                window.location.href = '/?open_cart=1';
                    
            },
            error: function (err) {
              console.error('❌ Error adding multiple items:', err);
              if (err && err.responseJSON && err.responseJSON.description) {
                alert('⚠️ ' + err.responseJSON.description);
              } else {
                alert('⚠️ Die maximale Menge dieses Artikels befindet sich bereits in deinem Warenkorb');
              }
            }
          });
        }
      });
    });
  });
   const params = new URLSearchParams(window.location.search);
    if (params.get('open_cart') === '1') {  
    const icon = document.querySelector('#cart-icon-bubble');
        if (icon) icon.click();
    }
     const url = new URL(window.location.href);
    url.searchParams.delete('open_cart');
    window.history.replaceState({}, document.title, url.pathname);
/** CUSOM 2b2b */
  if ($('.page-width-custom').hasClass('b2b')) {
    var firstB2B = $('input.b2b-option[type=radio]').not(':disabled').first();
    if (firstB2B.length && !firstB2B.prop('checked')) {
      var label = $('label[for="' + firstB2B.attr('id') + '"]');
    
      if (label.length) {
          label.trigger('click');
          
        } else {
          firstB2B.prop('checked', true).trigger('change');
      }
    }
  }
  handlePreisgruppeDisplay();
  function handlePreisgruppeDisplay() {
      var $fieldset = $('.variation-gruppe');
      var visibleOptions;
    
      if ($('.page-width-custom').hasClass('b2b')) {
        visibleOptions = $fieldset.find('label.b2b-option:not([disabled])').length;
      } else {
        visibleOptions = $fieldset.find('input.standard-option[type="radio"]:not(:disabled)').length;
      }
      console.log(visibleOptions);
      if (visibleOptions <= 1) {

        $fieldset.hide();
        $(".b2b").addClass('b2b-custom-box');
      } else {
        $fieldset.show();
      }
    }
  /** CUSTOM b2b  */
  $('.size-image').click(function (e) { 
    e.preventDefault();
    $(this).toggleClass('active');
  });

  var product_featured = document.querySelectorAll('.featured-product .product__media-list li');
  var product_featured_slider = document.querySelector('.featured-product .product__media-list');
  if (product_featured.length > 1) {
  var flkty = new Flickity(product_featured_slider, {
    pageDots: false,
    cellAlign: 'left',
    groupCells: true,
    wrapAround: true,
    autoPlay: false,
    prevNextButtons: true,
    freeScroll: true
  });
}
  
  /*** PDD SLIDER ***/

   var product_custom = document.querySelectorAll('.product-slider .product-grid li');
    if (product_custom.length > 4) {
      product_custom.forEach(function(product_item) {
        var product_slider = product_item.closest('.product-slider .product-grid');
        if (product_slider) {
          var flkty = new Flickity(product_slider, {
            pageDots: false,
            cellAlign: 'left',
            groupCells: true,
            wrapAround: true,
            autoPlay: false,
            prevNextButtons: true,
            freeScroll: true, 
          });
        }
      });
    }

    var product_custom = document.querySelectorAll('.product-slider .product-grid li');
      if (product_custom.length > 4) {
        product_custom.forEach(function(product_item) {
          var product_slider = product_item.closest('.product-slider .product-grid');
          if (product_slider) {
            var flkty = new Flickity(product_slider, {
               pageDots: false,
              cellAlign: 'left',
              groupCells: true,
              wrapAround: true,
              autoPlay: false,
              prevNextButtons: true,
              freeScroll: true, 
            });
          }
        });
      }
  
  
  
  $('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
  $('.product-single__gallery').on('change.flickity', function(event, index) {
      var $thumbnails = $('.product-single__thumbnails li');
      $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
      $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
  });
  $('.product-single__thumbnails li').first().addClass('active');
  
  // Thumbnail click event to change the gallery image
  $('.product-single__thumbnails li').on('click', function() {
      var index = $(this).index();
      $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
  });
  
  
  document.addEventListener("DOMContentLoaded", function() {
      const thumbsScroller = document.querySelector(".product-single__thumbnails");
      const btnPrev = document.querySelector("button.product__thumb-arrow.product__thumb-arrow--prev");
      const btnNext = document.querySelector("button.product__thumb-arrow.product__thumb-arrow--next");
      const scrollStep = 100; 
      const scrolledClass = "scrolled-end";
      // const extraItemsClass = "has-extra-items";
      // const minItems = 6; 
      // const items = thumbsScroller ? thumbsScroller.children : [];
  
      let hasScrolled = false; 
  
      function updateButtonState() {
        const isAtTop = thumbsScroller.scrollTop === 0;
    
        const threshold = 5; 
        const isAtBottom =
            thumbsScroller.scrollTop + thumbsScroller.clientHeight >= thumbsScroller.scrollHeight - threshold;
    
        btnPrev.disabled = isAtTop;
        btnNext.disabled = isAtBottom;
    
        if (hasScrolled && isAtBottom) {
            thumbsScroller.classList.add(scrolledClass);
        } else {
            thumbsScroller.classList.remove(scrolledClass);
        }
      }
  
  
      // function addExtraItemsClass() {
      //     if (items.length > minItems) {
      //         thumbsScroller.classList.add(extraItemsClass);
      //     } else {
      //         thumbsScroller.classList.remove(extraItemsClass);
      //     }
      // }
  
      if (thumbsScroller) {
          btnPrev.addEventListener("click", () => {
              thumbsScroller.scrollBy({ top: -scrollStep, behavior: "smooth" });
          });
  
          btnNext.addEventListener("click", () => {
              thumbsScroller.scrollBy({ top: scrollStep, behavior: "smooth" });
          });
  
          thumbsScroller.addEventListener("scroll", () => {
              hasScrolled = true; 
              updateButtonState();
          });
  
          //addExtraItemsClass();
  
          updateButtonState();
      }
  });
  
  
  
  const scriptTag = $('script[data-selected-variant]').first();  
  if (scriptTag.length) {
      const jsonData = JSON.parse(scriptTag.text().trim());
      const featuredMediaId = jsonData.featured_media?.id;  
      const sectionIdValue = $('input[name="section-id"]').val();
      const mediaId = `${sectionIdValue}-${featuredMediaId}`;
      
      if (mediaId) {
        var thumbnail = $(`li[data-att="${mediaId}"]`);
        // Trigger a click event on that element
        if (thumbnail.length) {
          thumbnail.click();
        }
      }
  }
  
  
  /*** PDD SLIDER ***/
  $(".hotspot-point").click(function () {
        let productHandle = $(this).data("product");
        let infoBox = $(this).next(".hotspot-product-info");
      
        if (productHandle) {
            $.getJSON(`/products/${productHandle}.json`, function (data) {
                let product = data.product;
                let vendor = product.vendor;
                let productHtml = `
                  <a href="/products/${product.handle}" class="hotspot-image-link">
                        <img src="${product.image.src}" class="hotspot-product-img">
                  </a>
                  <a href="/products/${product.handle}" class="hotspot-title-link">
                      <p class="product-vendor">${vendor}</p>
                      <p class="title-h3">${product.title}</p>
                      <p>
                        ${product.variants[0].price} €
                      </p>
                  </a>
                `;
                infoBox.find(".hotspot-product-content").html(productHtml);
                $(".hotspot-product-info").hide(); // Hide all other boxes
                infoBox.fadeIn(); // Show current box
            });
        }

        event.stopPropagation(); // Prevent closing when clicking on the hotspot
    });
   $(document).click(function (event) {
        if (!$(event.target).closest(".hotspot-product-info, .hotspot-point").length) {
            $(".hotspot-product-info").fadeOut();
        }
    });
  //End Point Section
  $('.footer-block.has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
   $('.notification-close').click(function (e) { 
        e.preventDefault();
        $('.notification-bar').hide();
         $('.utility-bar').addClass('active');
    });
});
//Swipper slider
$(document).ready(function(){
  ///// Tab Faq
  $(document).on('click','.acctab_title', function(e){
     if($(window).width() >= 768){
        $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }else{
       $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  ///// Tab Faq
});
//cookie top bar
function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
  document.cookie = name + "=" + value + "; expires=" + expires + "; path=/";
}

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

window.customElements.define("price-range1", PriceRange1);

//load more product
   document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;

                    
                    const newButton = tempDiv.querySelector('[data-pagination-btn]');
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "Mehr Produkte anzeigen";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Mehr Produkte anzeigen";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
  });
